"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AcTextboxButton_1 = require("../stamps/AcTextboxButton");
var AcDateStampButton_1 = require("../stamps/AcDateStampButton");
var AcSvgStampButtons_1 = require("../stamps/AcSvgStampButtons");
var AcSetPhraseRecentlyUsedButtons_1 = require("../stamps/AcSetPhraseRecentlyUsedButtons");
var AcStampButtonWrapper_1 = require("../stamps/AcStampButtonWrapper");
exports.AcPdfEditorStampMenu = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, height = _a.height;
    return (react_1.default.createElement("div", { style: { width: width, height: height } },
        react_1.default.createElement(AcStampButtonWrapper_1.AcStampButtonWrapper, null,
            react_1.default.createElement(AcTextboxButton_1.AcTextboxButton, null),
            react_1.default.createElement(AcDateStampButton_1.AcDateStampButton, null)),
        react_1.default.createElement(AcStampButtonWrapper_1.AcStampButtonWrapper, null,
            react_1.default.createElement(AcSvgStampButtons_1.AcSvgStampButtons, null)),
        react_1.default.createElement(AcStampButtonWrapper_1.AcStampButtonWrapper, null,
            react_1.default.createElement(AcSetPhraseRecentlyUsedButtons_1.AcSetPhraseRecentlyUsedButtons, null))));
};
exports.AcPdfEditorStampMenu.displayName = 'AcPdfEditorStampMenu';
//# sourceMappingURL=AcPdfEditorStampMenu.js.map